import React from 'react';
import { Info } from 'lucide-react';
import { Email } from '../types/email';
interface EmailCardProps {
  email: Email;
  isSelected: boolean;
  onClick: () => void;
  index: number;
}
const statusLabels = {
  processing: 'Processing',
  'auto-linked': 'Auto-Linked',
  'needs-review': 'Needs Review',
  'manually-linked': 'Manual Link'
};
export function EmailCard({
  email,
  isSelected,
  onClick,
  index
}: EmailCardProps) {
  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(date);
  };
  const getRefNumber = () => {
    if (email.references.length > 0) {
      return email.references[0].number;
    }
    return `EM${email.id.toUpperCase()}`;
  };
  return <tr onClick={onClick} className={`cursor-pointer border-b transition-colors ${isSelected ? 'bg-blue-50' : index % 2 === 0 ? 'bg-white hover:bg-gray-50' : 'bg-gray-50/50 hover:bg-gray-100'}`} style={{
    borderColor: 'var(--border-light)'
  }} data-id="element-1">
      <td className="px-4 py-3" data-id="element-2">
        <span className="text-blue-600 font-medium" data-id="element-3">{getRefNumber()}</span>
      </td>
      <td className="px-4 py-3 text-gray-700" data-id="element-4">
        {formatDate(email.receivedAt)}
      </td>
      <td className="px-4 py-3 text-gray-700" data-id="element-5">{statusLabels[email.status]}</td>
      <td className="px-4 py-3 text-gray-700" data-id="element-6">Inbound</td>
      <td className="px-4 py-3 text-gray-700" data-id="element-7">{email.from}</td>
      <td className="px-4 py-3 text-gray-700 max-w-md truncate" data-id="element-8">
        {email.subject}
      </td>
      <td className="px-4 py-3" data-id="element-9">
        <button className="p-1 text-blue-600 hover:bg-blue-100 rounded" data-id="element-10">
          <Info className="w-4 h-4" data-id="element-11" />
        </button>
      </td>
    </tr>;
}